const initialState = {
  pending: false,
  success: false,
  error: false,
};

const updatedPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PENDING':
      return {
        ...state,
        pending: action.payload,
      };
    case 'SUCCESS':
      return {
        ...state,
        success: action.payload,
      };
    case 'ERROR':
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default updatedPasswordReducer;
